import mediator from "@tvg/mediator";

export const resultsChangeTabEvent = ({
  textLabel,
  raceNumber,
  trackName
}: {
  textLabel: string;
  raceNumber: string;
  trackName?: string;
}) => {
  mediator.base.dispatch({
    type: "CHANGE_TAB_RESULTS",
    payload: {
      textLabel,
      raceNumber,
      trackName
    }
  });
};
